import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Posts from "./Posts";
import PaginationRounded from "./Pagination";
import '../components/Style/productcategory.css';

export const DesktopSection = ({
  loading,
  product,
  setPage,
  page,
  totalProduct,
  category,
  getCategory,
  brand,
  filterConfig,
  setSortConfig,
  sortConfig,
  brandConfig,
  brandList,
  clearFilter
}) => {
  const { t } = useTranslation();
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target) && 
          !event.target.closest('.filter-mobile-button')) {
        setShowMobileFilter(false);
      }
    };

    if (showMobileFilter) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMobileFilter]);

  const sortData = [
    { name: 'Price: Low to High', value: 'selling_price' },
    { name: 'Price: High to Low', value: '-selling_price' },
    { name: 'Latest', value: '-created_at' },
  ];

  const Brand = () => {
    return (
      <div className="brand-filter">
        <div className="filter-section-title">Brands</div>
        <div className="brand-list">
          {brand?.map((data, key) => (
            <div key={key} className="filter-option">
              <input
                id={`brand-${data.id}`}
                type="checkbox"
                value={data.id}
                checked={brandConfig?.value?.includes(String(data.id))}
                onChange={(event) => brandList(
                  brandConfig?.value?.includes(String(data.id)) ? 'remove' : 'add',
                  event.target.value
                )}
              />
              <label htmlFor={`brand-${data.id}`}>{data.name}</label>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const CategoryHierarchical = () => {
    return (
      <div className="category-tree">
        {category?.category?.map((cat, key1) => (
          <div key={key1}>
            <div
              className={`category-item ${!filterConfig ? 'active' : ''}`}
              onClick={() => getCategory('subcategory', 'category', cat.id)}
            >
              {cat.name}
            </div>
            <div className="subcategory">
              {category?.subcategory?.map((subcat, key2) => (
                <div key={key2}>
                  <div
                    className={`category-item ${subcat.id === filterConfig?.value ? 'active' : ''}`}
                    onClick={() => (getCategory('sub2category', 'subcategory', subcat.id), setPage(1))}
                  >
                    {subcat.name}
                  </div>
                  <div className="subcategory">
                    {category?.sub2category?.map((sub2cat, key3) =>
                      subcat.id === sub2cat.subcategory && (
                        <div key={key3}>
                          <div
                            className={`category-item ${sub2cat.id === filterConfig?.value ? 'active' : ''}`}
                            onClick={() => (getCategory('sub3category', 'subsubcategory', sub2cat.id), setPage(1))}
                          >
                            {sub2cat.name}
                          </div>
                          <div className="subcategory">
                            {category?.sub3category?.map((sub3cat, key4) =>
                              sub2cat.id === sub3cat.subsubcategory && (
                                <div
                                  key={key4}
                                  className={`category-item ${sub3cat.id === filterConfig?.value ? 'active' : ''}`}
                                  onClick={() => (getCategory(null, 'subsubsubcategory', sub3cat.id), setPage(1))}
                                >
                                  {sub3cat.name}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const Filter = () => {
    return (
      <div 
        ref={filterRef}
        className={`product-filter ${showMobileFilter ? 'show-mobile-filter' : ''}`}
      >
        <div className="filter-header">
          <div className="filter-header-text">Filters</div>
          <div className="filter-header-buttons">
            <button
              className="filter-header-button"
              onClick={clearFilter}
            >
              Clear All
            </button>
            <button
              className="filter-close-button"
              onClick={() => setShowMobileFilter(false)}
            >
              ✕
            </button>
          </div>
        </div>
        <div className="filter">
          <div className="filter-section">
            <div className="filter-section-title">Categories</div>
            <CategoryHierarchical />
          </div>
          <Brand />
        </div>
      </div>
    );
  };

  const Sort = () => {
    return (
      <div className="product-sort">
        <span className="sort-text">Sort by:</span>
        <select
          className="sort-select"
          onChange={(event) => setSortConfig({ 'lable': 'sort', 'value': event.target.value })}
          value={sortConfig?.value || ''}
        >
          <option value="">Select</option>
          {sortData?.map((sort, key) => (
            <option key={key} value={sort.value}>{sort.name}</option>
          ))}
        </select>
      </div>
    );
  };

  const FilterButtonForMobile = () => {
    return (
      <button 
        className="filter-mobile-button"
        onClick={() => setShowMobileFilter(true)}
      >
        <span>Filters</span>
      </button>
    );
  };

  return (
    <div className={showMobileFilter ? 'overlay-active' : ''}>
      <div className="sort-section">
        <FilterButtonForMobile />
        <Sort />
      </div>

      <div style={{ display: 'flex' }}>
        <Filter />
        <div className="products-list">
          <div className="product">
            {product?.map((post, key) => (
              <Posts key={key} post={post} />
            ))}
            <div style={{ width: 'calc(15rem + 3.5%)' }} />
            <div style={{ width: 'calc(15rem + 3.5%)' }} />
            {!(product?.length) && !loading && 
              <div style={{ width: '100%', textAlign: 'center', color: '#6c757d' }}>
                No available products at the moment. Apologies for any inconvenience.
              </div>
            }
          </div>
          <div className="default-pagination">
            <PaginationRounded
              totalProduct={totalProduct}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      </div>
      {showMobileFilter && <div className="mobile-filter-backdrop" onClick={() => setShowMobileFilter(false)} />}
    </div>
  );
};
